import http from '../../utils/http';
const rootUrl = '/api';
const dentalxUrl = '/dentalx/api';

const prices = {
	/**
	 * 价目表
	 * @returns
	 */
	listProductPrice(params) {
		return http.get( `${dentalxUrl}/dentalxListProductPrice`, params, { errCode: '@shining3d/xl-design-order.apiErr.prices' });
	},
};
export default prices;
